import { gql } from 'apollo-angular';

export const userOrganization = {
  GET_AUTHORIZED_ORGS: gql`
    query getOrganizationWithAccessToMicroServices(
      $first: Int
      $after: String
      $last: Int
      $before: String
      $where: OrganizationFilterInput
      $order: [OrganizationSortInput!]
    ) {
      organizations(
        first: $first
        after: $after
        last: $last
        before: $before
        where: $where
        order: $order
      ) {
        edges {
          node {
            id
            orgName
            orgCode
          }
        }
      }
    }
  `,

  GET_USER_PROFILE: gql`
    query userProfileRoles($id: UUID!) {
      userById(id: $id) {
        firstName
        lastName
        userName
        email
        usersInOrg {
          id
          isStaff
          displayOrder
          orgId
          org {
            id
            orgCode
            orgName
            orgType
            requireMFA
            tpaRule
            tpaRuleFilter
          }
          userId
          orgUsersForOrgRole {
            id
            orgRole {
              id
              orgId
              serviceRoleId
              serviceRole {
                id
                name
                dateStart
                dateExpire
              }
            }
          }
        }
      }

      selector: userClaims(
        where: {
          and: [
            { userId: { eq: $id } }
            { claimType: { eq: "AccountSelector" } }
          ]
        }
        first: 1
      ) {
        options: nodes {
          value: claimValue
        }
      }
    }
  `,
};
